/*@flow*/
import nested from 'lib/nested';

export default (): ID => {
  return nested(window, 'assetCompanyId', null);
};
